<template>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="fade">
        <template v-slot:activator="{ on }">
            <v-btn large color="#4F4F4F" class="mr-5 white--text" v-on="on" :disabled="disabled" @click="reload">แสดงตัวอย่าง</v-btn>
        </template>
        <v-card style="border-radius: unset; background-color: #8A8A8A" v-if="disabled === false">

            <v-layout pa-4 style="background-color: #000">
                <v-layout justify-space-between>
                    <v-flex xs4 class="text-start">
                        <v-btn icon dark @click="dialog = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-flex>
                    <v-flex xs4>
                        <span class="white--text titleHeader">Preview</span>
                    </v-flex>
                    <v-flex xs4 class="text-end">
<!--                        <v-btn dark text class="txt-head share-button" v-if="fullPreview" @click="dialog = false">เผยแพร่</v-btn>-->
                    </v-flex>
                </v-layout>
            </v-layout>


            <v-layout justify-center v-if="fullPreview">
                <v-flex shrink pa-8>

                    <v-layout column mx-auto class="full-page-preview">
                        <!-- Full preview area -->

                        <div class="mb-3" style="background-color: #fff;">

                            <v-layout justify-start mb-10>
                                <v-flex class="headTab" py-3 px-5>
                                    <v-icon large color="#FF5100" class="mx-5">bar_chart</v-icon>
                                    <div class="text-start">
                                      สถิติรายอุตสาหกรรมของไทย
                                    </div>
                                </v-flex>
                            </v-layout>


                            <StatCards :year="2560" :labor="839490"></StatCards>

                            <v-layout row wrap mx-3>
                                <v-flex lg6 pa-3 mb-5 :class="{'d-flex':$vuetify.breakpoint.mdAndUp, 'flex-column':$vuetify.breakpoint.mdAndUp}">

                                    <div v-if="data.graph_type_id === typeOfGraph.pie">
                                        <CardPieChart
                                                :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                                class="mb-5"
                                                v-if="chartLoaded"
                                                barcolor="#4F4F4F"
                                                :title="data.title_th"
                                                :year="data.latestyear"
                                                :chartdata="chartData.graph.labels"
                                                :options="chartData.graph.values"
                                                :piecolor="areaColor"
                                                dataname="Value"
                                                unit="ล้านบาท"
                                        ></CardPieChart>
                                    </div>

                                    <div v-else-if="data.graph_type_id === typeOfGraph.line">
                                        <CardLineChart
                                                :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                                class="mb-5"
                                                v-if="chartLoaded"
                                                barcolor="#4F4F4F"
                                                :title="data.title_th"
                                                :chartdata="chartData.graph.labels"
                                                :options="chartData.graph.values"
                                                dataname="Value"
                                                unit="ล้านบาท"
                                        ></CardLineChart>
                                    </div>

                                    <div v-else-if="data.graph_type_id === typeOfGraph.barV">
                                        <CardBarChart
                                                :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                                class="mb-5"
                                                v-if="chartLoaded"
                                                barcolor="#4F4F4F"
                                                :title="data.title_th"
                                                :chartdata="chartData.graph.labels"
                                                :options="chartData.graph.values"
                                                dataname="Value"
                                                unit="ล้านบาท"
                                        ></CardBarChart>
                                    </div>

                                    <div v-else-if="data.graph_type_id === typeOfGraph.barH">
                                        <CardHBarChart
                                                :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                                class="mb-5"
                                                v-if="chartLoaded"
                                                :title="data.title_th"
                                                :year="data.latestyear"
                                                :chartdata="chartData.graph.labels"
                                                :options="chartData.graph.values"
                                                dataname="Value"
                                                unit="ล้านบาท"
                                        ></CardHBarChart>
                                    </div>

                                    <div v-else-if="data.graph_type_id === typeOfGraph.donut">
                                        <CardDoughnutChart
                                                :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                                class="mb-5"
                                                v-if="chartLoaded"
                                                :title="data.title_th"
                                                barcolor="#4F4F4F"
                                                :dncolor="areaColor"
                                                :chartdata="chartData.graph.labels"
                                                :options="chartData.graph.values"
                                                dataname="Value"
                                                unit="ล้านบาท"
                                        ></CardDoughnutChart>
                                    </div>

                                    <v-layout justify-space-between :style="$vuetify.breakpoint.mdAndUp ? {'flex': '0'}:{}">
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="#FF5100">
                                                <v-icon class="white--text">add</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดูเพิ่มเติม
                                        </span>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="primary">
                                                <v-icon class="white--text">get_app</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดาวน์โหลดภาพ
                                        </span>
                                        </v-flex>
                                    </v-layout>

                                </v-flex>
                                <v-flex lg6 pa-3 mb-5 :class="{'d-flex':$vuetify.breakpoint.mdAndUp, 'flex-column':$vuetify.breakpoint.mdAndUp}">
                                    <CardLineChart
                                            style="flex: 1"
                                            class="mb-5"
                                            :chartdata="['how','i','can','test']"
                                            :options="[10,24,35,43]"
                                            dataname="Value"
                                            title="Title preview"
                                            barcolor="#4F4F4F"
                                            unit="ล้านบาท"
                                    ></CardLineChart>
                                    <v-layout justify-space-between style="flex: 0">
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="#FF5100">
                                                <v-icon class="white--text">add</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดูเพิ่มเติม
                                        </span>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="primary">
                                                <v-icon class="white--text">get_app</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดาวน์โหลดภาพ
                                        </span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex lg6 pa-3 mb-5 :class="{'d-flex':$vuetify.breakpoint.mdAndUp, 'flex-column':$vuetify.breakpoint.mdAndUp}">
                                    <CardPieChart
                                            style="flex: 1"
                                            title="Title preview"
                                            class="mb-5"
                                            unit="คน"
                                            barcolor="#4F4F4F"
                                            :chartdata="['how','i','can','test']"
                                            :options="[10,24,35,43]"
                                            maxregion="max region"
                                            max="num of max region"
                                            :piecolor="['#FF4F23','#FF8162','#507CD6','#000000','#8A8A8A']"
                                            dataname="Value"
                                    ></CardPieChart>
                                    <v-layout justify-space-between style="flex: 0">
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="#FF5100">
                                                <v-icon class="white--text">add</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดูเพิ่มเติม
                                        </span>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="primary">
                                                <v-icon class="white--text">get_app</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดาวน์โหลดภาพ
                                        </span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex lg6 pa-3 mb-5 :class="{'d-flex':$vuetify.breakpoint.mdAndUp, 'flex-column':$vuetify.breakpoint.mdAndUp}">
                                    <CardLineChart
                                            style="flex: 1;"
                                            title="การเติบโตของอุตสาหกรรมสร้างสรรค์ คำนวณจากมูลค่า ณ ราคาประจำปี (Current Price)"
                                            class="mb-5"
                                            unit="เปอร์เซ็นต์"
                                            barcolor="#4F4F4F"
                                            :chartdata="['2554','2555','2556','2557','2558','2559','2560']"
                                            :options="[3.52,9.55,6.63,1.47,7.00,5.06,6.24]"
                                            maxregion="ปี 2555 มีอัตราการเจริญเติบโตของอุตสาหกรรมสร้างสรรค์มากที่สุด"
                                            max="คิดเป็น 9.55"
                                            dataname="Value"
                                    ></CardLineChart>
                                    <v-layout justify-space-between style="flex: 0">
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="#FF5100">
                                                <v-icon class="white--text">add</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดูเพิ่มเติม
                                        </span>
                                        </v-flex>
                                        <v-flex shrink>
                                            <v-btn small depressed fab class="mx-2" color="primary">
                                                <v-icon class="white--text">get_app</v-icon>
                                            </v-btn>
                                            <span style="user-select: none;cursor: pointer">
                                            ดาวน์โหลดภาพ
                                        </span>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>

                        </div>

                        <v-layout justify-center mb-12>
                            <v-flex shrink mx-3>
                                <v-btn large elevation="0"
                                       class="white--text prev-button"
                                       @click="fullPreview = false">
                                    <v-icon>arrow_left</v-icon>
                                    ย้อนกลับ
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-layout>

                </v-flex>
            </v-layout>

            <v-layout justify-center v-else>
                <v-flex pa-8>

                    <v-layout column>
                        <!-- preview area -->

                        <v-layout justify-center mb-2>

                            <v-flex xs7 v-if="data.graph_type_id === typeOfGraph.pie">
                                <CardPieChart
                                        :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                        class="mb-5"
                                        v-if="chartLoaded"
                                        barcolor="#4F4F4F"
                                        :title="data.title_th"
                                        :year="data.latestyear"
                                        :chartdata="chartData.graph.labels"
                                        :options="chartData.graph.values"
                                        :piecolor="areaColor"
                                        dataname="Value"
                                        unit="ล้านบาท"
                                ></CardPieChart>
                            </v-flex>

                            <v-flex xs7 v-else-if="data.graph_type_id === typeOfGraph.line">
                                <CardLineChart
                                        :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                        class="mb-5"
                                        v-if="chartLoaded"
                                        barcolor="#4F4F4F"
                                        :title="data.title_th"
                                        :chartdata="chartData.graph.labels"
                                        :options="chartData.graph.values"
                                        dataname="Value"
                                        unit="ล้านบาท"
                                ></CardLineChart>
                            </v-flex>

                            <v-flex xs7 v-else-if="data.graph_type_id === typeOfGraph.barV">
                                <CardBarChart
                                        :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                        class="mb-5"
                                        v-if="chartLoaded"
                                        barcolor="#4F4F4F"
                                        :title="data.title_th"
                                        :chartdata="chartData.graph.labels"
                                        :options="chartData.graph.values"
                                        dataname="Value"
                                        unit="ล้านบาท"
                                ></CardBarChart>
                            </v-flex>

                            <v-flex xs7 v-else-if="data.graph_type_id === typeOfGraph.barH">
                                <CardHBarChart
                                        :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                        class="mb-5"
                                        v-if="chartLoaded"
                                        :title="data.title_th"
                                        :year="data.latestyear"
                                        :chartdata="chartData.graph.labels"
                                        :options="chartData.graph.values"
                                        dataname="Value"
                                        unit="ล้านบาท"
                                ></CardHBarChart>
                            </v-flex>

                            <v-flex xs7 v-else-if="data.graph_type_id === typeOfGraph.donut">
                                <CardDoughnutChart
                                        :style="$vuetify.breakpoint.mdAndUp ? {'flex': '1'}:{}"
                                        class="mb-5"
                                        v-if="chartLoaded"
                                        :title="data.title_th"
                                        barcolor="#4F4F4F"
                                        :dncolor="areaColor"
                                        :chartdata="chartData.graph.labels"
                                        :options="chartData.graph.values"
                                        dataname="Value"
                                        unit="ล้านบาท"
                                ></CardDoughnutChart>
                            </v-flex>

                        </v-layout>

                        <v-layout justify-center>
                            <v-flex shrink mx-3>
                                <v-btn large elevation="0"
                                       class="white--text prev-button"
                                       @click="dialog = false">
                                    <v-icon>arrow_left</v-icon>
                                    ย้อนกลับ
                                </v-btn>
                            </v-flex>
                            <v-flex shrink mx-3>
                                <v-btn large elevation="0"
                                       class="white--text next-button"
                                       @click="fullPreview = true">
                                    <v-icon>arrow_right</v-icon>
                                    ถัดไป
                                </v-btn>
                            </v-flex>
                        </v-layout>

                    </v-layout>

                </v-flex>
            </v-layout>

            <Footer type="website" style="position: absolute; bottom: 0; width: 100%;"></Footer>

        </v-card>
    </v-dialog>
</template>

<script>
    import Footer from "./Footer"
    import CardHBarChart from "./PreviewComponents/CardHBarChart"
    import CardBarChart from "./PreviewComponents/CardBarChart"
    import CardDoughnutChart from "./PreviewComponents/CardDoughnutChart"
    import CardLineChart from "./PreviewComponents/CardLineChart"
    import CardPieChart from "./PreviewComponents/CardPieChart"
    import StatCards from "./PreviewComponents/StatCards"
    import Service from "../services"

    export default {
        name: "Preview",
        props: ['data', 'disabled'],
        components: {
            Footer,
            CardHBarChart,
            CardBarChart,
            CardDoughnutChart,
            CardLineChart,
            CardPieChart,
            StatCards
        },
        data: () => ({
            dialog: false,
            fullPreview: false,
            chartLoaded: false,
            chartData: {},
            typeOfGraph: {
                pie: 1,
                line: 2,
                barV: 3,
                barH: 4,
                donut: 5
            },
            areaColor: [
                '#D1DDEF',
                '#A3B9DC',
                '#7A9ACD',
                '#4D78BD',
                '#1147B4',
                '#FBDED3',
                '#FFC3AD',
                '#FF8E62',
                '#FE6F38',
                '#FFCF0B',
                '#EBEBEB',
                '#D4D4D4',
                '#8A8A8A',
                '#4F4F4F',
                '#000000'
            ]

        }),
        computed: {
            topic_id: function () {
                return this.data.topic_id;
            },
            graph_type_id: function () {
                return this.data.graph_type_id;
            },
        },
        watch: {
                topic_id: function () {
                    // console.log('topic')
                    Service.preview.getChartDataFromTopic(this.data.topic_id).then(res => {
                        this.chartData = res;
                    });
                }

        },
        methods: {
            reload() {
                this.chartLoaded = false;
                setTimeout(() => {
                    this.chartLoaded = true;
                }, 200)
            }

        }

    }
</script>

<style scoped>

    .prev-button {
        border: solid 1px #FFF !important;
        background-color: transparent !important;
        min-width: 125px !important;
    }

    .next-button {
        border: solid 1px #FF4F23 !important;
        background-color: #FF4F23 !important;
        min-width: 125px !important;
    }

    .share-button {
        background-color: #FF4F23 !important;
    }

    .headTab {
        background: #000;
        color: #fff;
        text-transform: uppercase;
        font-size: 20px;
        display: flex;
        align-items: center;
    }

    .full-page-preview {
        font-size: 13px;
        width: 80%;
    }

</style>
